import { supabase } from './supabaseClient';

export function minutesUntil(iso) {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  if (Number.isNaN(ms)) return null;
  return Math.max(1, Math.ceil(ms / 60000));
}

/** Normalize supabase.functions.invoke results for non-2xx JSON bodies. */
export async function invokeEdgeFunction(name, body) {
  const { data, error } = await supabase.functions.invoke(name, { body });

  if (!error) {
    return { data: data ?? {}, error: null };
  }

  let payload = data;
  if ((!payload || typeof payload !== 'object') && error.context) {
    try {
      payload = await error.context.json();
    } catch {
      payload = null;
    }
  }

  return {
    data: payload && typeof payload === 'object' ? payload : {},
    error: error.message || 'Request failed.'
  };
}
